import styled from 'styled-components';

export default styled.hr`
	margin: ${props => props.theme.vr * 1}rem auto;
`;
